import { useEffect, useMemo, useState } from "react";
import { Chip, Flex } from "@goodfill/ui-components";
import { ChartViewIcon } from "./assets/ChartViewIcon";
import { DashboardViewIcon } from "./assets/DashboardViewIcon";
import { ListViewIcon } from "./assets/ListView";
import "./styles/BondCard.scss";

export type BondListViewId = "compact" | "wide" | "charts";

export interface BondCardViewItem {
  id: BondListViewId;
  label: string;
}

interface Props {
  items: BondCardViewItem[];
  selectedViewId: BondListViewId;
  setSelectedViewId: (id: BondListViewId) => void;
}

export const viewItems: BondCardViewItem[] = [
  {
    id: "compact",
    label: "Dashboard",
  },
  {
    id: "wide",
    label: "List View",
  },
  {
    id: "charts",
    label: "Charts",
  },
];

export const BondCardViewSelector: React.FC<Props> = ({ items = [], selectedViewId, setSelectedViewId }) => {
  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("active-menu-item") || "compact");
  const viewItems = useMemo(
    () =>
      items.map(({ id, ...item }) => ({
        selected: id === selectedViewId,
        onClick: () => {
          setSelectedViewId(id);
          setActiveMenu(id);
        },
        id,
        ...item,
      })),
    [items, selectedViewId, setSelectedViewId],
  );
  useEffect(() => {
    localStorage.setItem("active-menu-item", activeMenu);
  }, [activeMenu]);
  return (
    <Flex>
      <Chip className="text-[14px] px-0-important pr-2 font-medium leading-8" size="medium" disabled={true}>
        View Style:
      </Chip>
      {viewItems.map(({ label, id, onClick, selected }) => (
        <Chip
          className="dashboard-nav-icons cursor-pointer"
          size="medium"
          font="semibold"
          grouped={true}
          key={id}
          onClick={onClick}
        >
          {label === "Dashboard" ? (
            <DashboardViewIcon isSelected={activeMenu === "compact" ? true : false} />
          ) : label === "List View" ? (
            <ListViewIcon isSelected={activeMenu === "wide" ? true : false} />
          ) : (
            <ChartViewIcon isSelected={activeMenu === "charts" ? true : false} />
          )}
        </Chip>
      ))}
    </Flex>
  );
};
